import { request } from "@/Api";
import {
    Badge,
    Menu,
    MenuItem,
    Popover,
    Popper,
    TextField,
    useTheme,
} from "@mui/material";
import { useEffect, useRef, useState } from "react";
import {
    ADDON_ROW_ID_PREFIX,
    LINE_GROUP_ROW_ID_PREFIX,
    LINE_ITEM_ROW_ID_PREFIX,
} from "./constants";
import { store } from "./bidStore";

import { useSelector } from "react-redux";
import { selectOpenCommentKey, setOpenCommentKey } from "./bidSlice";
import { useDispatch } from "react-redux";
import { CommentInputWithPersonTagging } from "@/common/Comments";
import CommentThread from "@/common/CommentThread";

export default function ContextMenuCellWrapper({ cell, children }) {
    const [hover, setHover] = useState(false);
    const [anchorEl, setAnchorEl] = useState(null);
    const [commentOpen, setCommentOpen] = useState(false);
    const theme = useTheme();

    const dispatch = useDispatch();

    const openCommentKey = useSelector(selectOpenCommentKey);

    const field = cell.columnId;
    const modelType = cell.rowId.split("-")[0];
    const modelId = cell.rowId.split("-")[1];

    const commentKey = `${modelType}-${modelId}-${field}`;
    const comment = store.bid.comments_by_key?.[commentKey];
    const commentId = comment?.id;

    const wrapperRef = useRef();

    const getCommentPayload = (parentId, commentContent) => {
        const payload = {
            parent_id: parentId,
            root_id: comment?.root_id,
            description: commentContent,
            model_type: "bid",
            model_instance_id: store.bid.id,
        };
        if (!parentId) {
            payload.meta = {
                comment_key: commentKey,
            };
        }
        return payload;
    };

    const handleContextMenu = (e) => {
        if (!modelType) {
            return;
        }

        e.preventDefault();
        setAnchorEl(wrapperRef.current);
    };
    const handleCloseContextMenu = () => {
        setCommentOpen(false);
        setAnchorEl(null);
        dispatch(setOpenCommentKey(null));
    };
    const handleComment = () => {
        setCommentOpen(true);
    };
    const handleAddComment = (parentId, commentContent) => {
        const payload = getCommentPayload(parentId, commentContent);
        request.post(`/comments`, payload).then((res) => {
            if (!parentId) {
                store.bid.comments_by_key[commentKey] = res.data;
            }
        });
    };
    const handleEditComment = (commentId, commentContent) => {
        request
            .patch(`/comments/${commentId}`, {
                description: commentContent,
                model_type: "bid",
                model_instance_id: store.bid.id,
            })
            .then((res) => {
                if (commentId == comment.id) {
                    store.bid.comments_by_key[commentKey] = {
                        ...comment,
                        description: commentContent,
                    };
                }
            });
    };
    const handleDeleteComment = (cId) => {
        if (!cId) {
            return;
        }
        const deleteRoot = cId == commentId;
        request.delete(`/comments/${cId}`).then(() => {
            if (deleteRoot) {
                delete store.bid.comments_by_key[commentKey];
            }
        });
    };

    useEffect(() => {
        if (!openCommentKey) {
            return;
        }
        if (openCommentKey && openCommentKey == commentKey) {
            setTimeout(() => {
                setCommentOpen(true);
                setAnchorEl(wrapperRef.current);
            }, 200);
        }
    }, [openCommentKey]);

    return (
        <div
            ref={wrapperRef}
            style={{ width: "100%", height: "100%" }}
            onContextMenu={handleContextMenu}
            onMouseEnter={() => setHover(true)}
            onMouseLeave={() => setHover(false)}
        >
            {children}
            <div
                hidden={!commentId}
                style={{
                    position: "absolute",
                    top: 1.5,
                    right: 1.5,
                    zIndex: 0,
                }}
            >
                <div
                    style={{
                        background: theme.palette.primary.main,
                        width: 6,
                        height: 6,
                        borderRadius: "50%",
                    }}
                ></div>
            </div>
            {(hover || openCommentKey == commentKey) && (
                <>
                    <Menu
                        disableRestoreFocus
                        onPointerDown={(e) => {
                            e.stopPropagation();
                        }}
                        onKeyDown={(e) => {
                            e.stopPropagation();
                        }}
                        anchorOrigin={{ vertical: "top", horizontal: "right" }}
                        anchorEl={anchorEl}
                        BackdropProps={{
                            sx: {
                                backdropFilter: "blur(0px)",
                            },
                        }}
                        open={Boolean(anchorEl)}
                        onClose={handleCloseContextMenu}
                    >
                        <MenuItem onClick={handleComment}>Comment</MenuItem>
                    </Menu>
                    <Popover
                        BackdropProps={{
                            sx: {
                                backdropFilter: "blur(0px)",
                            },
                        }}
                        slotProps={{
                            paper: {
                                style: {
                                    boxShadow: "none",
                                    background: "#00000000",
                                },
                            },
                        }}
                        onPointerDown={(e) => {
                            e.stopPropagation();
                        }}
                        onKeyDown={(e) => {
                            e.stopPropagation();
                        }}
                        open={commentOpen}
                        onClose={handleCloseContextMenu}
                        anchorEl={anchorEl}
                        anchorOrigin={{ vertical: "top", horizontal: "right" }}
                    >
                        <CommentThread
                            rootComment={comment}
                            onResolve={handleDeleteComment}
                            onReply={handleAddComment}
                            onCancel={handleCloseContextMenu}
                            onEdit={handleEditComment}
                        />
                    </Popover>
                </>
            )}
        </div>
    );
}
